<template>
  <section style="overflow: hidden">
    <Title title="언론사별 가장 많이 본 뉴스" desc="각 언론사의 가장 많이 본 기사 1건을 제공합니다." />
    <swiper ref="mySwiper" class="mt20" :options="swiperOption">
      <swiper-slide v-for="(articleList, index) in naverChunk" :key="index" @slideChange="onSwiperChanged">
        <div class="article-grid">
          <ArticleItem v-for="(item, index) in articleList" :key="`naver-article-${index}`" :item="item" :index="index" :cardType="true" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-controller">
      <div @click.stop="prev" class="arrow-button">
        <svg width="16" height="16" viewBox="0 0 24 24" style="fill: #a0a0a0">
          <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
        </svg>
      </div>
      <div class="page-index">
        <span class="paging" :style="isDarkMode ? 'color: white !important' : ''">{{ currentIndex + 1 }} / {{ naverChunk.length }}</span>
      </div>
      <div @click.stop="next" class="arrow-button">
        <svg width="16" height="16" viewBox="0 0 24 24" style="fill: #a0a0a0">
          <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import Title from "./Title"
import ArticleItem from "./ArticleItem"
import "swiper/swiper.min.css"
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import { mapGetters } from "vuex"
export default {
  props: ["naverArticles"],
  components: { Title, ArticleItem, Swiper, SwiperSlide },
  data() {
    return {
      naverChunk: [],
      currentIndex: 0,
      swiperOption: {
        allowTouchMove: false
      }
    }
  },

  directives: {
    swiper: directive
  },
  computed: {
    ...mapGetters({ isDarkMode: "isDarkMode" }),
    currentPageArticleList() {
      return this.naverChunk[this.currentIndex]
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  watch: {
    naverArticles() {
      this.fetch()
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.naverChunk = this.chunk(this.naverArticles, 4)
    },
    chunk(array, size) {
      const chunked = []
      let index = 0

      while (index < array.length) {
        chunked.push(array.slice(index, index + size))
        index += size
      }

      return chunked
    },
    prev() {
      this.currentIndex = this.currentIndex - 1
      if (this.currentIndex < 0) {
        this.currentIndex = this.naverChunk.length - 1
      }
      this.slideTo(this.currentIndex)
    },
    next() {
      this.currentIndex = this.currentIndex + 1
      if (this.currentIndex >= this.naverChunk.length) {
        this.currentIndex = 0
      }
      this.slideTo(this.currentIndex)
    },
    slideTo(index) {
      this.swiper.slideTo(index, 500, false)
    },
    onSwiperChanged(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.article-grid {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.swiper-controller {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px auto 30px auto;
}
.arrow-button {
  width: 30px;
  height: 30px;
  border: 1px solid #a0a0a0;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-index {
  border: 1px solid #e6e6ea;
  color: #303030;
  text-align: center;
  padding: 5px 20px;
  font-size: 1rem;
  border-radius: 20px;
  margin: 0 30px;
  .paging {
    font-size: 12px;
    color: #606060;
  }
}
</style>
